import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  withStyles,
  Typography,
  Box,
  Collapse,
  IconButton,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { connect } from "react-redux";
import { appService } from "../../App/app.service";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";
import ErrorBoundary from "../../components/ErrorBoundary";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import AddIcon from "@material-ui/icons/Add";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import TorqDashboardTable from "./TorqNewDataTable";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import Drilldown from "../../components/Drilldown/DrilldownWithSLD";
import ExpectedAcvPage from "../../EnhancedInsights/NewWaterFall/ExpectedAcvPage";


// Styles
const styles = (theme) => ({
  root: {},
  formControl: {
    minWidth: 120,
  },
  storedSelection: {
    border: "1px solid #d4e9d4",
    borderRadius: "4px",
    padding: theme.spacing(2),
    backgroundColor: "#f0f7f0",
  },
  selectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    paddingBottom: theme.spacing(1),
  },
  selectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: "#2e7d32",
  },
  selectionContent: {
    paddingTop: theme.spacing(2),
  },
  filterLabel: {
    fontWeight: 600,
    fontSize: "0.813rem",
    color: "#555",
    marginBottom: theme.spacing(0.75),
    marginTop: theme.spacing(2),
    "&:first-child": {
      marginTop: 0,
    },
  },
  filterValue: {
    fontSize: "0.875rem",
    color: "#333",
    padding: theme.spacing(1, 1.5),
    backgroundColor: "#e8e8e8",
    borderRadius: "4px",
    display: "inline-block",
  },
  compareButton: {
    backgroundColor: "#2196f3",
    color: "white",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1976d2",
    },
    "&:disabled": {
      backgroundColor: "#e0e0e0",
      color: "#9e9e9e",
    },
  },
  addButton: {
    backgroundColor: "#90caf9",
    color: "white",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#64b5f6",
    },
    "&:disabled": {
      backgroundColor: "#e0e0e0",
      color: "#9e9e9e",
    },
  },
  clearButton: {
    color: "#f44336",
    textTransform: "none",
    border: "1px solid #f44336",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#ffebee",
    },
    "&:disabled": {
      color: "#9e9e9e",
      borderColor: "#e0e0e0",
    },
  },
  emptySelection: {
    border: "1px dashed #bdbdbd",
    borderRadius: "4px",
    padding: theme.spacing(1.5),
    backgroundColor: "#fafafa",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#9e9e9e",
    minHeight: "100px",
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
    [theme.breakpoints.down('md')]: {
      '& table': {
        minWidth: '800px',
      }
    }
  },
  tabsContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
  tabPanel: {
    width: '100%',
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const TorqDashboardNew = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
  const [state, setState] = useState({
    loading: false,
    compareMode: false,
    
    Cust_Type: ["All"],
    closed_fiscal_quarter: ["All"],
    
    storedSelections: [],
    selectionsExpanded: true,
    
    selection1Data: null,
    selection2Data: null,
    
    activeTab: 0,
    
    // First-level drilldown state
    location: "overview",
    selectedDrilldownStage: "",
    lastStage: false,
    header: "",
    filtersForDrilldown: [],
    activeSelectionIndex: null,
    
    // Second-level drilldown state
    secondLevelLocation: null,
  });

  useEffect(() => {
    props.getFunnelFilters();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setState({
      ...state,
      [name]:
        value.length === 0
          ? ["All"]
          : state[name].length === 1 && state[name].includes("All")
          ? value.filter((v) => v !== "All").length > 0
            ? value.filter((v) => v !== "All")
            : ["All"]
          : value.includes("All")
          ? ["All"]
          : value,
    });
  };

  const handleAddSelection = () => {
    if (state.storedSelections.length >= 2) return;

    const newSelection = {
      Cust_Type: state.Cust_Type,
      closed_fiscal_quarter: state.closed_fiscal_quarter,
    };

    setState((prev) => ({
      ...prev,
      storedSelections: [...prev.storedSelections, newSelection],
      Cust_Type: ["All"],
      closed_fiscal_quarter: ["All"],
    }));
  };

  const handleClear = () => {
    setState((prev) => ({
      ...prev,
      storedSelections: [],
      selection1Data: null,
      selection2Data: null,
      compareMode: false,
      Cust_Type: ["All"],
      closed_fiscal_quarter: ["All"],
      selectionsExpanded: true,
      activeTab: 0,
      location: "overview",
      selectedDrilldownStage: "",
      filtersForDrilldown: [],
      activeSelectionIndex: null,
      secondLevelLocation: null,
    }));
    props.clearDrilldownData();
    props.clearExpectedAcvData();
  };

  const toggleSelection = () => {
    setState((prev) => ({
      ...prev,
      selectionsExpanded: !prev.selectionsExpanded,
    }));
  };

  const handleTabChange = (event, newValue) => {
    setState((prev) => ({
      ...prev,
      activeTab: newValue,
    }));
  };

  const handleCompare = async () => {
    if (state.storedSelections.length !== 2) {
      alert("Please add two selections before comparing");
      return;
    }

    setState((prev) => ({ ...prev, loading: true, compareMode: true }));

    try {
      const selection1 = state.storedSelections[0];
      const selection2 = state.storedSelections[1];

      let filters1 = [];
      if (!selection1.Cust_Type.includes("All") && selection1.Cust_Type.length > 0) {
        filters1.push({ name: "Cust_Type", value: selection1.Cust_Type });
      }
      if (!selection1.closed_fiscal_quarter.includes("All") && selection1.closed_fiscal_quarter.length > 0) {
        filters1.push({ name: "closed_fiscal_quarter", value: selection1.closed_fiscal_quarter });
      }

      let filters2 = [];
      if (!selection2.Cust_Type.includes("All") && selection2.Cust_Type.length > 0) {
        filters2.push({ name: "Cust_Type", value: selection2.Cust_Type });
      }
      if (!selection2.closed_fiscal_quarter.includes("All") && selection2.closed_fiscal_quarter.length > 0) {
        filters2.push({ name: "closed_fiscal_quarter", value: selection2.closed_fiscal_quarter });
      }

      const [data1, data2] = await Promise.all([
        appService.getTorqDashboardData(filters1),
        appService.getTorqDashboardData(filters2),
      ]);

      setState((prev) => ({
        ...prev,
        selection1Data: data1.message,
        selection2Data: data2.message,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching comparison data:", error);
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  const passFiltersForDrilldown = (selectionIndex, segmentArray, solutionCategory, stages) => {
    let filtersArray = [];
    
    const selection = state.storedSelections[selectionIndex];

    if (selection && !selection.closed_fiscal_quarter.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Closed Fiscal Qtr.", value: selection.closed_fiscal_quarter.sort() },
      ];
    }

    if (selection && !selection.Cust_Type.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Customer Type", value: selection.Cust_Type.sort() },
      ];
    }

    if (segmentArray && segmentArray.length > 0) {
      filtersArray = [
        ...filtersArray,
        { title: "Customer Segment", value: segmentArray.sort() },
      ];
    }

    if (solutionCategory) {
      filtersArray = [
        ...filtersArray,
        { title: "Solution Category", value: [solutionCategory] },
      ];
    }

    if (stages) {
      filtersArray = [
        ...filtersArray,
        { title: "Stage", value: stages },
      ];
    }

    return filtersArray;
  };

  const handleChangeLocation = (location, stage, lastStage, key, selectionIndex, segmentArray, solutionCategory) => {
    const header = lastStage || key === "won"
      ? `${stage} Opportunities`
      : key === "lost"
      ? `Lost / Disqualified from ${Array.isArray(stage) ? "Open" : stage} stage`
      : key === "cameTo"
      ? `Came to ${stage} stage`
      : key === "movedOn"
      ? `Moved Forward from ${stage} stage`
      : `Opportunities at ${stage} stage`;

    const stages = Array.isArray(stage) ? stage : [stage];

    setState((prev) => ({
      ...prev,
      location: location,
      selectedDrilldownStage: stage,
      lastStage: lastStage,
      header,
      filtersForDrilldown: passFiltersForDrilldown(selectionIndex, segmentArray, solutionCategory, stages),
      activeSelectionIndex: selectionIndex,
      secondLevelLocation: null, // Reset second level when first level changes
    }));

    if (location !== "overview") {
      const activeSelection = state.storedSelections[selectionIndex];
      
      let filters = [];
      
      if (activeSelection && !activeSelection.Cust_Type.includes("All") && activeSelection.Cust_Type.length > 0) {
        filters.push({ name: "Cust_Type", value: activeSelection.Cust_Type });
      }
      if (activeSelection && !activeSelection.closed_fiscal_quarter.includes("All") && activeSelection.closed_fiscal_quarter.length > 0) {
        filters.push({ name: "closed_fiscal_quarter", value: activeSelection.closed_fiscal_quarter });
      }
      
      if (segmentArray && segmentArray.length > 0) {
        filters.push({ name: "Acct_Size_Segment", value: segmentArray });
      }
      
      if (solutionCategory) {
        filters.push({ name: "Solution_Cat", value: [solutionCategory] });
      }

      props.getClosedDrilldownOnGraph(key, {
        stage: Array.isArray(stage) ? stage : [stage],
        filters: filters,
      });
    } else {
      props.clearDrilldownData();
      props.clearExpectedAcvData();
    }
  };

  const handleChangeLocationBack = (location) => {
    setState((prev) => ({
      ...prev,
      location: location,
      secondLevelLocation: location,
    }));
  };

  const handleSecondLevelDrilldown = (location, oppId) => {
    console.log("Second level drilldown:", oppId);
    setState((prev) => ({
      ...prev,
      secondLevelLocation: location,
    }));
    props.getOpenOppData(oppId);
  };

  const stepBack = () => {
    setState((prev) => ({
      ...prev,
      secondLevelLocation: null,
    }));
    props.clearExpectedAcvData();
  };

  const renderStoredSelection = (selection, index) => {
    const { classes } = props;
    
    if (!selection) {
      return (
        <Box className={classes.emptySelection}>
          <Typography variant="body2">
            Selection {index + 1}
          </Typography>
        </Box>
      );
    }

    return (
      <Box className={classes.storedSelection}>
        <Box 
          className={classes.selectionHeader}
          onClick={toggleSelection}
        >
          <Box className={classes.selectionTitle}>
            <CheckCircleIcon style={{ color: "#4caf50", fontSize: 18 }} />
            <Typography variant="body2" style={{ fontWeight: 600 }}>
              Selection {index + 1}
            </Typography>
          </Box>
          <IconButton size="small">
            {state.selectionsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
        
        <Collapse in={state.selectionsExpanded}>
          <Box className={classes.selectionContent}>
            <Typography className={classes.filterLabel}>
              Closed Fiscal Quarter:
            </Typography>
            <Typography className={classes.filterValue}>
              {selection.closed_fiscal_quarter.join(", ")}
            </Typography>
            
            <Typography className={classes.filterLabel}>
              Customer Type:
            </Typography>
            <Typography className={classes.filterValue}>
              {selection.Cust_Type.join(", ")}
            </Typography>
          </Box>
        </Collapse>
      </Box>
    );
  };

  const renderComparisonResults = () => {
    const { classes } = props;
    
    if (state.loading) {
      return (
        <>
          <Grid item xs={12} md={6}>
            <Paper style={{ padding: 20 }}>
              <Skeleton variant="rect" animation="wave" height={400} width="100%" />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper style={{ padding: 20 }}>
              <Skeleton variant="rect" animation="wave" height={400} width="100%" />
            </Paper>
          </Grid>
        </>
      );
    }

    if (isTablet) {
      return (
        <Grid item xs={12}>
          <Paper style={{ padding: 20 }}>
            <Tabs
              value={state.activeTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              className={classes.tabsContainer}
            >
              <Tab label="Selection 1 Results" />
              <Tab label="Selection 2 Results" />
            </Tabs>
            
            {state.activeTab === 0 && (
              <Box className={classes.tableWrapper}>
                <TorqDashboardTable 
                  data={state.selection1Data.data}
                  uniqueSolutionCategories={state.selection1Data.uniqueSolutionCategories}
                  uniqueSegments={state.selection1Data.uniqueSegments}
                  uniqueStages={state.selection1Data.uniqueStages}
                  winRateData={state.selection1Data.otherData}
                  handleChangeLocation={(location, stage, lastStage, key, segmentArray, solutionCategory) => 
                    handleChangeLocation(location, stage, lastStage, key, 0, segmentArray, solutionCategory)
                  }
                  dataTest={'selectionOneTable'}
                />
              </Box>
            )}
            
            {state.activeTab === 1 && (
              <Box className={classes.tableWrapper}>
                <TorqDashboardTable 
                  data={state.selection2Data.data}
                  uniqueSolutionCategories={state.selection2Data.uniqueSolutionCategories}
                  uniqueSegments={state.selection2Data.uniqueSegments}
                  uniqueStages={state.selection2Data.uniqueStages}
                  winRateData={state.selection2Data.otherData}
                  handleChangeLocation={(location, stage, lastStage, key, segmentArray, solutionCategory) => 
                    handleChangeLocation(location, stage, lastStage, key, 1, segmentArray, solutionCategory)
                  }
                  dataTest={'selectiontwoTable'}
                />
              </Box>
            )}
          </Paper>
        </Grid>
      );
    }

    return (
      <>
        <Grid item xs={12} md={6}>
          <Paper style={{ padding: 20 }}>
            <Typography variant="h6" style={{ marginBottom: 10, fontWeight: 600 }}>
              Selection 1 Results
            </Typography>
            <Box className={classes.tableWrapper}>
              <TorqDashboardTable 
                data={state.selection1Data.data}
                uniqueSolutionCategories={state.selection1Data.uniqueSolutionCategories}
                uniqueSegments={state.selection1Data.uniqueSegments}
                uniqueStages={state.selection1Data.uniqueStages}
                winRateData={state.selection1Data.otherData}
                handleChangeLocation={(location, stage, lastStage, key, segmentArray, solutionCategory) => 
                  handleChangeLocation(location, stage, lastStage, key, 0, segmentArray, solutionCategory)
                }
                dataTest={'selectionOneTable'}
              />
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper style={{ padding: 20 }}>
            <Typography variant="h6" style={{ marginBottom: 10, fontWeight: 600 }}>
              Selection 2 Results
            </Typography>
            <Box className={classes.tableWrapper}>
              <TorqDashboardTable 
                data={state.selection2Data.data}
                uniqueSolutionCategories={state.selection2Data.uniqueSolutionCategories}
                uniqueSegments={state.selection2Data.uniqueSegments}
                uniqueStages={state.selection2Data.uniqueStages}
                winRateData={state.selection2Data.otherData}
                handleChangeLocation={(location, stage, lastStage, key, segmentArray, solutionCategory) => 
                  handleChangeLocation(location, stage, lastStage, key, 1, segmentArray, solutionCategory)
                }
                dataTest={'selectionTwoTable'}
              />
            </Box>
          </Paper>
        </Grid>
      </>
    );
  };

  const { classes } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <AddHeaderDescriptionWithHelperText
          header={`HyperSoc vs Hyperautomation`}
          description={`Compare the performance across any combination of dimensions across various time frames.`}
          helperTextCharts={props.helperTextCharts}
        />
      </Grid>

      {props.funnelFilters !== "" ? (
        <>
          <Grid item xs={12} md={4}>
            <Paper style={{ padding: '10px', height: '100%' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-fiscalQuarter-label"
                      style={{
                        color: !state.closed_fiscal_quarter.includes("All") ? "#4472c4" : "#000",
                      }}
                    >
                      Closed Fiscal Qtr.:
                    </InputLabel>
                    <Select
                      data-test="Closed_Fiscal_Quarter"
                      labelId="select-fiscalQuarter-label"
                      id="select-fiscalQuarter"
                      value={state.closed_fiscal_quarter}
                      onChange={handleChange}
                      label="Closed Fiscal Quarter"
                      name="closed_fiscal_quarter"
                      multiple
                      MenuProps={MenuProps}
                      disabled={state.storedSelections.length >= 2}
                    >
                      <MenuItem value={"All"}>All</MenuItem>
                      {props.funnelFilters !== "" &&
                        props.funnelFilters.closed_fiscal_quarter &&
                        props.funnelFilters.closed_fiscal_quarter
                          .filter((item) => item !== "")
                          .map((y) => (
                            <MenuItem key={y} value={y}>
                              {y}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-Cust_Type-label"
                      style={{
                        color: !state.Cust_Type.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      Cust Type:
                    </InputLabel>
                    <Select
                      data-test="Cust_Type"
                      labelId="Cust_Type-label"
                      id="Cust_Type"
                      multiple
                      value={state.Cust_Type}
                      onChange={handleChange}
                      name="Cust_Type"
                      MenuProps={MenuProps}
                      disabled={state.storedSelections.length >= 2}
                    >
                      <MenuItem value="All">All</MenuItem>
                      {props.funnelFilters.Cust_Type &&
                        props.funnelFilters.Cust_Type.map((custType) => (
                          <MenuItem key={custType.Cust_Type} value={custType.Cust_Type}>
                            {custType.Cust_Type}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} md={8}>
            <Grid style={{ padding: '10px', height: '100%' }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4}>
                  <Button
                    data-test="add-selection"
                    variant="outlined"
                    color="primary"
                    onClick={handleAddSelection}
                    disabled={state.storedSelections.length >= 2}
                    startIcon={<AddIcon />}
                    fullWidth
                    size="medium"
                  >
                    Add Selection ({state.storedSelections.length}/2)
                  </Button>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Button
                    data-test="compare"
                    variant="contained"
                    className={classes.compareButton}
                    onClick={handleCompare}
                    disabled={state.storedSelections.length !== 2}
                    startIcon={<CompareArrowsIcon />}
                    fullWidth
                    size="medium"
                  >
                    Compare
                  </Button>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Button
                    data-test="clear"
                    variant="outlined"
                    className={classes.clearButton}
                    onClick={handleClear}
                    disabled={state.storedSelections.length === 0}
                    fullWidth
                    size="medium"
                  >
                    Clear all
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            {renderStoredSelection(state.storedSelections[0], 0)}
          </Grid>

          <Grid item xs={12} md={6}>
            {renderStoredSelection(state.storedSelections[1], 1)}
          </Grid>
        </>
      ) : (
        <Grid item xs={12}>
          <Paper style={{ padding: 10 }}>
            <Skeleton
              variant="rect"
              animation="wave"
              height={60}
              width="100%"
              style={{ margin: "10px" }}
            />
          </Paper>
        </Grid>
      )}

      {props.funnelFilters !== "" && state.compareMode && (
        <ErrorBoundary>
          {renderComparisonResults()}
        </ErrorBoundary>
      )}

      {/* First-level Drilldown */}
      {state.location === "drilldownOnGraph" && state.selectedDrilldownStage !== "" && state.secondLevelLocation !== "drilldownOppId" && (
        <Grid
          item
          xs={12}
          style={{ position: "absolute", width: "100%", marginTop: "30px", zIndex: 1000 }}
        >
          <SingleLevelDrilldown
            header={state.header}
            back={handleChangeLocationBack}
            filters={state.filtersForDrilldown}
          >
            <Drilldown
              header={state.header}
              Value_Label={props.Value_Label}
              body={props.drilldownOnGraphData}
              company={props.company}
              handleSecondLevelDrilldown={handleSecondLevelDrilldown}
            />
          </SingleLevelDrilldown>
        </Grid>
      )}

      {/* Second-level Drilldown */}
      {state.secondLevelLocation === "drilldownOppId" && (
        <Grid
          item
          xs={12}
          style={{ position: "absolute", width: "100%", marginTop: "30px", zIndex: 1001 }}
        >
          <SingleLevelDrilldown
            header={"Opportunity Change Events"}
            back={handleChangeLocationBack}
            stepBack={stepBack}
            filters={[]}
          >
            <ExpectedAcvPage
              body={props.ExpectedAcvData}
              Value_Label={props.Value_Label}
            />
          </SingleLevelDrilldown>
        </Grid>
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  const { user, funnelFilters, drilldownOnGraphData, ExpectedAcvData } = state.app;

  return {
    company: user.company,
    funnelFilters,
    Value_Label: user.Value_Label,
    drilldownOnGraphData,
    ExpectedAcvData,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getFunnelFilters: () => {
    dispatch({ type: "get_funnel_filters_request" });
    appService.getTorqNewDashboardFilters().then(
      (json) => {
        dispatch({ type: "get_funnel_filters_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_funnel_filters_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_funnel_filters_failure", error });
      }
    );
  },
  getClosedDrilldownOnGraph: (key, filters) => {
    console.log(key, filters);
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.closedDrilldownOnGraph(key, filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].map(
          (item, index) => {
            let x = {
              ...item,
              OppNo: index + 1,
            };
            return x;
          }
        );

        tempOpportunities.sort((a, b) => (a.ACV > b.ACV ? -1 : 1));

        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
            columns: json.message.columns,
          },
        };
        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  clearDrilldownData: () => {
    dispatch({ type: "clear_drilldown_data" });
  },
  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => {
        dispatch({ type: "get_expectedAcv_drilldown_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_expectedAcv_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },
  clearExpectedAcvData: () => {
    dispatch({ type: "clear_expected_acv_data" });
  },
});

const connectedTorqDashboardNew = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TorqDashboardNew));

export default connectedTorqDashboardNew;